import { graphql } from "./generated/index.js"

export const fetchAsset = graphql(`
  query fetchAsset($id: Int!) {
    asset: assets_by_pk(id: $id) {
      ...AssetFields
    }
  }
`)

// `object` as a whole variable so a column the caller left out is genuinely
// ABSENT from the insert and the database default applies.
export const insertAsset = graphql(`
  mutation insertAsset($object: assets_insert_input!) {
    insert_assets_one(object: $object) {
      ...AssetFields
    }
  }
`)

export const updateAsset = graphql(`
  mutation updateAsset($id: Int!, $_set: assets_set_input!) {
    update_assets_by_pk(pk_columns: { id: $id }, _set: $_set) {
      ...AssetFields
    }
  }
`)

export const deleteAsset = graphql(`
  mutation deleteAsset($id: Int!) {
    delete_assets_by_pk(id: $id) {
      id
    }
  }
`)

export const deleteAssets = graphql(`
  mutation deleteAssets($ids: [Int!]!) {
    delete_assets(where: { id: { _in: $ids } }) {
      affected_rows
      returning {
        id
      }
    }
  }
`)

// A page of assets matching `$where` (assetWhere builds it), each with how many
// records use it and the first few of them, plus the whole match's count and size.
export const searchAssets = graphql(`
  query searchAssets(
    $where: assets_bool_exp!
    $limit: Int!
    $offset: Int!
    $order_by: [assets_order_by!]!
  ) {
    assets(where: $where, limit: $limit, offset: $offset, order_by: $order_by) {
      ...AssetFields
      attachments_aggregate {
        aggregate {
          count
        }
      }
      attachments(limit: 3, order_by: [{ created_at: asc }]) {
        id
        schema_key
        record {
          ...RequiredRecordFields
        }
      }
    }
    total: assets_aggregate(where: $where) {
      aggregate {
        count
        sum {
          size
        }
      }
    }
  }
`)

// One count per library view; each `$…` is that view's assetWhere.
export const countAssets = graphql(`
  query countAssets(
    $all: assets_bool_exp!
    $image: assets_bool_exp!
    $audio: assets_bool_exp!
    $video: assets_bool_exp!
    $document: assets_bool_exp!
    $unattached: assets_bool_exp!
  ) {
    all: assets_aggregate(where: $all) {
      aggregate {
        count
      }
    }
    image: assets_aggregate(where: $image) {
      aggregate {
        count
      }
    }
    audio: assets_aggregate(where: $audio) {
      aggregate {
        count
      }
    }
    video: assets_aggregate(where: $video) {
      aggregate {
        count
      }
    }
    document: assets_aggregate(where: $document) {
      aggregate {
        count
      }
    }
    unattached: assets_aggregate(where: $unattached) {
      aggregate {
        count
      }
    }
  }
`)

// The records an asset is attached to, and through which field.
export const fetchAssetAttachments = graphql(`
  query fetchAssetAttachments($assetId: Int!) {
    attachments: record_attachments(
      where: { asset_id: { _eq: $assetId } }
      order_by: [{ created_at: asc }]
    ) {
      id
      schema_key
      label
      is_primary
      record {
        ...RequiredRecordFields
      }
    }
  }
`)

// Every asset matching `$where`, unpaged — for the media matcher, which only
// asks for unattached files under a folder.
export const fetchAssetsWhere = graphql(`
  query fetchAssetsWhere($where: assets_bool_exp!) {
    assets(where: $where, order_by: [{ name: asc }]) {
      ...AssetFields
    }
  }
`)

// Records of a type with the one `data` key a media matcher reads.
export const fetchRecordsWithDataKey = graphql(`
  query fetchRecordsWithDataKey($type: String!, $key: String!) {
    records(where: { type: { _eq: $type }, data: { _has_key: $key } }) {
      ...RequiredRecordFields
      value: data(path: $key)
    }
  }
`)

export const fetchRecordsOfType = graphql(`
  query fetchRecordsOfType($type: String!) {
    records(where: { type: { _eq: $type } }) {
      ...RequiredRecordFields
    }
  }
`)
